module.exports = __webpack_public_path__ + "img/caseManagement.1525a7fa.png";